(() => {
  angular
    .module('complianceFrameworkApp')
    .run(appRun)
    .config(config);

  /* ngInject */
  function appRun($rootScope, config) {
    // Useful debug for logging all routes
    // console.log($state.get());

    $rootScope.config = config;

    // eslint-disable-next-line angular/on-watch
    $rootScope.$on('$stateChangeStart', checkLoggedIn);
  }

  /* ngInject */
  function config($locationProvider, $httpProvider) {
    $locationProvider.html5Mode(true);
    $httpProvider.interceptors.push('httpInterceptorService');
  }

  /* ngInject */
  function checkLoggedIn($state, sessionService) {
    return (event, toState, _toParams) => {
      const requireLogin = toState.data.requireLogin;

      if (requireLogin && angular.isUndefined(typeof sessionService.getAuthToken())) {
        event.preventDefault();
        $state.go('unauthenticated.login');
      }
    };
  }
})();
